import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

// Actions
import {
  selectPoiBrand,
  unSelectPoiBrands,
} from "../../../actions/map-view/poi/PoiSelectionActions";
import {
  getPoiHierarchy,
  setPoiStatus,
  setSelected,
} from "../../../actions/map-view/poi/PoiActions";

// Constants and Utils
import { Status } from "../../../constants/GeneralConstants";

// Components
import NestedList from "../../../components/nested-list/NestedList";
import Spinner from "../../../components/spinner/Spinner";

export default function PointsOfInterestTab({ cityId, cityBBox }) {
  const dispatch = useDispatch();

  // Selector - poi dataList
  const dataList = useSelector((state) => state.poi.dataList);

  // Selector State
  const getPoiLoading = useSelector((state) => state.poi.getPoiLoading);
  const dataListCityId = useSelector((state) => state.poi.cityId);

  const brandLabelToId = useSelector((state) => state.poi.brandLabelToId);
  const sectorLabelToId = useSelector((state) => state.poi.sectorLabelToId);
  const sectorToBrandMap = useSelector((state) => state.poi.sectorToBrandMap);
  const brandToSectorMap = useSelector((state) => state.poi.brandToSectorMap);
  const brandIdToLabel = useSelector((state) => state.poi.brandIdToLabel);
  const brandLoadingMap = useSelector((state) =>
    Object.keys(state.poiSelection.getBrandInfoLoading).reduce(
      (acc, eachBrandId) => {
        if (!state.poiSelection.getBrandInfoLoading[eachBrandId]) {
          return acc;
        }

        const brandLabel = brandIdToLabel[eachBrandId];
        acc[brandLabel] = true;
        return acc;
      },
      {}
    )
  );

  // Dispatch
  useEffect(() => {
    if (dataList.length === 0 || dataListCityId !== cityId) {
      dispatch(getPoiHierarchy(cityId));
    }
  }, [dispatch]);

  // Functions
  function actionOnAddButtonSelect(selectedIndex, label) {
    dispatch(setSelected(selectedIndex, label));
  }

  function actionOnAddButtonStatus(selectedIndex, label, status) {
    const brandId = brandLabelToId[label];
    const poiTypeId = brandToSectorMap[brandId];

    if (brandId) {
      status === Status.CHECKED
        ? dispatch(selectPoiBrand(cityId, cityBBox, brandId, poiTypeId))
        : dispatch(unSelectPoiBrands([brandId]));
      return;
    }
    const sectorId = sectorLabelToId[label];
    const brandIds = sectorToBrandMap[sectorId];
    status === Status.CHECKED
      ? brandIds.forEach((brandId) =>
          dispatch(selectPoiBrand(cityId, cityBBox, brandId, poiTypeId))
        )
      : dispatch(unSelectPoiBrands(brandIds));
  }

  function actionOnAddButton(label, status) {
    dispatch(setPoiStatus(label, status));
  }
  // Loading
  if (getPoiLoading) {
    return (
      <div className="d-flex justify-content-center">
        <Spinner />
      </div>
    );
  }
  return (
    <>
      <h2 className="mb-3">Points Of Interest</h2>
      <hr className="my-3"></hr>
      <NestedList
        data={dataList}
        brandLoadingMap={brandLoadingMap}
        setSelected={actionOnAddButtonSelect}
        setAdded={actionOnAddButton}
        setAddButtonStatus={actionOnAddButtonStatus}
        selectAllAttr={true}
        shouldShowCheckboxes={true}
        onCheckboxChange={actionOnAddButtonStatus}
      />
    </>
  );
}
